import { deviceTypes } from 'z-js-commons';

export default {
    info: {
        title: 'CERCA TRA LE VERIFICHE ZANICHELLI',
        description:
            'Trovi le Idee per insegnare dei tuoi libri. Scrivi nel campo di ricerca: ti saranno suggeriti tutti gli argomenti che hanno verifiche associate.',
        name: 'ZanichelliNavItem',
        tutorialName: 'verifica_tab-Zanichelli'
    },
    [deviceTypes.DESKTOP]: {
        popoverPlacement: 'right',
        xPlacement: 'RIGHT',
        yPlacement: 'MIDDLE',
        xOffset: -5,
        yOffset: 0
    },
    [deviceTypes.PHONE]: {
        popoverPlacement: 'bottom',
        xPlacement: 'RIGHT',
        yPlacement: 'MIDDLE',
        xOffset: -5,
        yOffset: 0
    }
};
